import { render, staticRenderFns } from "./Drug.vue?vue&type=template&id=1fd3e332&scoped=true&"
import script from "./Drug.vue?vue&type=script&lang=js&"
export * from "./Drug.vue?vue&type=script&lang=js&"
import style0 from "./Drug.vue?vue&type=style&index=0&id=1fd3e332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd3e332",
  null
  
)

export default component.exports